import { Component, OnInit, ViewChild } from '@angular/core';
import { OrganizationInfo } from '../model/organization';
import { RegistrationService } from '../services/registration.servcie';
import { Router } from "@angular/router";
import { PaginationComponent } from "src/app/pagination/pagination.component";
import { OrganizationStatus } from '../model/organizationstatus';
import { AuthService } from '../auth/auth.service';
import { OrganizationFiles } from '../model/organizationfiles';
import { SpinnerService } from '../spinner/spinner.service';
import { CanComponentDeactivate } from '../services/navigation-gaurd.service';
import { Observable } from 'rxjs';

declare function invokeFailToastr(title,message);
declare function invokeSuccessToastr(title,message);
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: [  ]
})
export class AdminComponent implements OnInit, CanComponentDeactivate {

 @ViewChild('tblRegistration')
  public paginationCtrl: PaginationComponent;
  
public organizationList: any[];
public pagedOrganizationList: any[];
public organizationInfo: OrganizationInfo;
public registrationStatus: OrganizationStatus;
public organizationFiles: OrganizationFiles;
public registrationStatusHistory: OrganizationStatus[];
public status: string = '';
public notes: string = '';
public selectedOrganizationGuid: string = '';
public user = this._authService.currentUser;
public isDbCallInProgress: boolean = false;
public isUpdateStatusButtonDisabled: boolean = false;

constructor(private readonly _registrationService: RegistrationService,
  private _authService: AuthService,
   private readonly _router: Router,
   private readonly _spinner: SpinnerService) {

    this.organizationFiles = {
      LogoFileName: '',
      LogoFileUrl: '',
      InsuranceFileName: '',
      InsuranceFileUrl: ''
    };

    this.registrationStatus = {
      OrganizationGuid: '',
      Status: '',
      Notes: '',
      CreatedDateTime: '',
      LastUpdatedDateTime: '',
    };
      this.organizationInfo = {
      OrganizationGuid: '',
      OrganizationName: '',
      ContactPersonName: '',
      ContactPersonEmailAddress: '',
      ContactPersonPhone: '',
      PublicEmail: '',
      Phone: '',
      Street: '',
      City: '',
      State: '',
      Zip: '',
      Country: '',
      URL: '',
      Hours: '',
      Type: '',
      FoundedOn: '',
      LicNo: '',
      MissionStatement: '',
      EIN: '',
      IsCourtAppointedServicesAccepted: '',
      IsCommunityServiceCreditQualified: '',
      IsActiveGenralLiabilityPolicy: '',
      IsInsuranceLoaded: false,
      LogoFileName: '',
      IsLogoUploaded: false,
      InsuranceFileName: '',
      InsuranceNumber:'',
      InsuranceCompanyName:'',
      Status:'',
      OperationHours: [],
      Programs: []
  };
this.registrationStatusHistory = [];
   }

canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
   return true;
  }
  
   ngOnInit() {
     this.DataBind();
  }

public afterOrgListSort(data: any[]): void {
  this.organizationList = data;
  this.paginationCtrl.Bind(this.organizationList);
}

onAfterBind(data:any[]):void {
  this.pagedOrganizationList = data;
}

goToPage(n: any[]): void {
  this.pagedOrganizationList = n;
  //this.myAssignedCase =  n;
}

public VieworganizationDetails(orgGuid: string) {
this.GetRegistrationDetails(orgGuid);
  $('#orgDteailsModal').modal('show');
}

public getNotesHistory(orgGuid) {
  let that = this;
  this._registrationService.getOrganizationNotes(orgGuid).subscribe((result) => {
    console.log(result);
    if(result != undefined && result != 'ERROR') {
     // that.organizationInfo =JSON.parse(result) ;
     that.registrationStatusHistory = JSON.parse(result);
    } else {
    }
    
  }, (err) => {
    console.log(err);
  });
}
public ViewOrganizationStatus(orgGuid: string, orgStatus: string) {  
  
  this.selectedOrganizationGuid = orgGuid;
  this.status = orgStatus;
  this.getNotesHistory(orgGuid);
  this.GetRegistrationDetails(orgGuid);
  $('#statusModal').modal('show');
  }

public DataBind(){
let that = this;
that.isDbCallInProgress = true;
this._registrationService.getallRequest().subscribe((result) => {
      console.log(result);
      that.isDbCallInProgress = false;
      if(result != undefined && result != 'ERROR') {
        that.organizationList = result;
        that.paginationCtrl.Bind(that.organizationList);
      } else {
      }
      
    }, (err) => {
      console.log(err);
    });
}

public getSelectedResources(resources) {
 return Array.prototype.map.call(resources, function(item) { return item.Value; }).join(", "); 
}

public getSelectedLanguages(languages) {
 // return Array.prototype.map.call(languages, s => s.Value).toString();
 return Array.prototype.map.call(languages, function(item) { return item.Value; }).join(", "); 
}

public getSelectedAgeTypes(ageTypes) {
 return Array.prototype.map.call(ageTypes, function(item) { return item.Value; }).join(", "); 
}

public GetRegistrationDetails(orgGuid){
let that = this;
this._registrationService.getRegistrationDetails(orgGuid).subscribe((result) => {
      console.log(result);
      if(result != undefined && result != 'ERROR') {
        that.organizationInfo =JSON.parse(result) ;
        this._registrationService.getOrganizationFileUrls(orgGuid).subscribe((filesresult) => {
          console.log(filesresult);
          if(filesresult != undefined && filesresult != 'ERROR') {
              that.organizationFiles = filesresult;
          }

        }, (fileserr) => {
          console.log(fileserr);
        });

      } else {
      }
      
    }, (err) => {
      console.log(err);
    });
}

public setInitialValues () {
  this.notes = '';
}

public updateStatus () {
  let that = this; 
  that._spinner.show();
  that.isUpdateStatusButtonDisabled = true;
  let createdBy = that.user.firstName + " " + that.user.lastName;
  let data = {AgencyDetails: that.organizationInfo, OrganizationGuid: this.selectedOrganizationGuid,  Status: that.status, Notes: that.notes, CreatedBy: createdBy}
  console.log('Request: ' + JSON.stringify(data));
  //that._fileUploadService.uploadFiles(this.yccFiles, this.organizationInfo.OrganizationGuid);
   that._registrationService.updateRegistrationStatus(data).subscribe((result) => {
    console.log(result);
    that._spinner.hide();
    that.isUpdateStatusButtonDisabled = false;
    if(result != undefined && result != 'ERROR') {
          invokeSuccessToastr('Successfully Submitted', 'The application has been successfuly submitted to DA.');
          that.getNotesHistory(that.selectedOrganizationGuid);
          that.DataBind();
          that.setInitialValues();
          
    } else {
      invokeFailToastr('Failed',
            'Something went wrong and the application has not be submitted. Please try again.');
             that._router.navigate(['error']);
    }
    
  }, (err) => {
    console.log(err);
     invokeFailToastr('Failed',
            'Something went wrong and the application has not be submitted. Please try again.');
             that._router.navigate(['error']);
  });
}
}